//@flow
import {useSelector} from 'react-redux';
import {actions as CategoryActions} from '../duck';

import {useActions} from '../../../utils/globalStore';
import type {RootState} from '../..';
import type {Category} from '../../../entities';

const categoriesSelector = (state: RootState) =>
  state.categories.categories || [];

export function useCategories(): Category[] {
  return useSelector(categoriesSelector);
}

const categoriesFilterSelector = (state: RootState) => ({
  categoriesFilter: state.categories.categoriesFilter,
  isFetchingCategories: state.categories.isFetching,
  paginationCategories: state.categories.paginationFilter,
});

export function useCategoriesFilter() {
  return useSelector(categoriesFilterSelector);
}

const categoriesActions = {
  fetchCategoriesSearch: CategoryActions.fetchCategoriesSearch,
  resetCategoriesFilter: CategoryActions.resetCategoriesFilter,
};

export function useCategoriesActions() {
  const actions = useActions(categoriesActions);
  return actions;
}
